import React, { useState } from "react";
import BotonBuscarChico from "../botones/BotonBuscarChico.js";
import PopupBuscarPersona from "../../popups/PopupBuscarPersona.js";
import styles from "./CampoBuscarPersona.module.css";
import { ApellidoNombre } from "../../funciones/FuncionesPersona.js";

const CampoBuscarPersona = (props) => {
  const width = props.width;
  const editar = props.editar;
  const nombreCampo = props.nombre;
  const persona = props.valor;
  const [mostrarPopup, setMostrarPopup] = useState(false);

  const onPersonaElegida = (persona) => {
    props.onPersonaElegida(nombreCampo, persona);
    setMostrarPopup(false);
  }

  const onClickBuscar = (event) => {
    event.preventDefault();
    setMostrarPopup(true);
  }

  const onCancelarPopup = () => {
    setMostrarPopup(false);
  }

  return (
    <div className={`${styles.contenedor}`}>
      <div className={`${styles.nombrePersona}`} width={width}>
        {ApellidoNombre(persona)}
      </div>
      {editar && (
        <React.Fragment>
          <BotonBuscarChico
            estilo={`${styles.boton}`}
            onClick={onClickBuscar}
          />
        </React.Fragment>
      )}
      <PopupBuscarPersona
        visible={mostrarPopup}
        valor={persona}
        onPersonaElegida={onPersonaElegida}
        onCancelar={onCancelarPopup}
      />
    </div>
  );
};

export default CampoBuscarPersona;
